import apiClient from "../../lib/apiClient";

export const authAPI = {
  // POST /api/auth/register
  register: async (userData) => {
    try {
      const response = await apiClient.post("/auth/register", userData);
      const { token, user } = response.data;

      // Lưu token vào localStorage
      localStorage.setItem("token", token);

      return { success: true, data: { user, token } };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Đăng ký thất bại",
      };
    }
  },

  // POST /api/auth/login
  login: async (credentials) => {
    try {
      const response = await apiClient.post("/auth/login", credentials);
      const { token, user } = response.data;

      // Lưu token vào localStorage
      localStorage.setItem("token", token);

      return { success: true, data: { user, token } };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Đăng nhập thất bại",
      };
    }
  },

  // GET /api/auth/profile
  getProfile: async () => {
    try {
      const response = await apiClient.get("/auth/profile");
      return { success: true, data: response.data.user };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy thông tin thất bại",
      };
    }
  },

  // Logout (client-side)
  logout: () => {
    localStorage.removeItem("token");
    // Không sử dụng window.location.href để tránh reload
    // Để authStore xử lý navigation
  },
};
